import {ValueObject} from '@s-ui/domain'

import {SellerErrorsFactory} from '../Errors/factory.js'

export class SubscriptionCommitmentSellerValueObject extends ValueObject {
  #totalMonths
  #monthlyPrice
  #kmIncluded
  #kmIncludedPeriod
  #targetBuyer

  constructor({totalMonths, monthlyPrice, kmIncluded, kmIncludedPeriod, targetBuyer}) {
    super()
    this.#totalMonths = totalMonths
    this.#monthlyPrice = monthlyPrice
    this.#kmIncluded = kmIncluded
    this.#kmIncludedPeriod = kmIncludedPeriod
    this.#targetBuyer = targetBuyer
  }

  static create({totalMonths, monthlyPrice, kmIncluded, kmIncludedPeriod, targetBuyer}) {
    if (!(typeof totalMonths === 'number' && totalMonths >= 0)) {
      throw SellerErrorsFactory.invalidRequestSellerError('totalMonths must be a non-negative number')
    }
    if (!(typeof monthlyPrice === 'number' && monthlyPrice > 0)) {
      throw SellerErrorsFactory.invalidRequestSellerError('monthlyPrice must be a positive number')
    }
    if (!targetBuyer) {
      throw SellerErrorsFactory.invalidRequestSellerError('targetBuyer is required')
    }
    return new SubscriptionCommitmentSellerValueObject({
      totalMonths,
      monthlyPrice,
      kmIncluded,
      kmIncludedPeriod,
      targetBuyer
    })
  }

  getCommitment() {
    return {
      totalMonths: this.#totalMonths,
      monthlyPrice: this.#monthlyPrice,
      kmIncluded: this.#kmIncluded,
      kmIncludedPeriod: this.#kmIncludedPeriod,
      targetBuyer: this.#targetBuyer
    }
  }
}
